export default function({ state, commit, dispatch }, message) {
    commit('startMessagingPatient', message.patient)

    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : message.provider) + '/patient/' + message.patient + '/message',
        data: message
    }, {
        root: true
    })
    .then((response) => {
        commit('finishMessagingPatient', message.patient)
        commit('updatePatient', response)
		return response
    })
    .catch((error) => {
        commit('finishMessagingPatient', message.patient)
		throw error
    })
}
